import { Fragment, useState } from "react";
import { Transition } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";
import { mergeClasses } from "../../redux/constants";

const people = [
  { id: 1, name: "Durward Reynolds", unavailable: false },
  { id: 2, name: "Kenton Towne", unavailable: false },
  { id: 3, name: "Therese Wunsch", unavailable: false },
  { id: 4, name: "Benedict Kessler", unavailable: true },
  { id: 5, name: "Katelyn Rohan", unavailable: false },
];

export default function MultiSelectListBox(props) {
  const [selected, setSelected] = useState([]);
  const [expanded, setExpanded] = useState(false);

  function handleSelection(e) {
    if (selected.includes(e)) {
      setSelected(selected.filter((option) => option != e));
      props.handleSelected(selected.filter((option) => option != e));
    } else {
      setSelected([...selected, e]);
      props.handleSelected([...selected, e]);
    }
  }
  return (
    <div
      className={mergeClasses(
        "relative w-full ",
        props.listboxClasses ? props.listboxClasses : ""
      )}
    >
      <span
        className="w-full p-1 h-10 overflow-hidden flex flex-wrap gap-x-1 gap-y-1 border border-gray-300 bg-gray-100 rounded-md"
        onClick={() => setExpanded(!expanded)}
      >
        {selected.map((item) => (
          <label className="bg-green-200 rounded-md px-2 py-1">{item}</label>
        ))}
      </span>
      {expanded ? (
        <div className="absolute my-1 bg-gray-100 z-30 border border-gray-200 overflow-y-auto max-h-48 rounded-md w-full flex flex-col items-start">
          {props.options.map((item) => (
            <div
              className={
                "w-full py-1 text-left" +
                (selected.includes(item)
                  ? " border-l-4 border-green-500 bg-gray-300"
                  : "")
              }
              onClick={() => handleSelection(item)}
            >
              <label className="pl-2">{item}</label>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
